// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClientQuoteWrapper_wrapper__2O9Xv","slider":"ClientQuoteWrapper_slider__2MSoo"};